import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

const message = 'The account number must be between 5 and 17 characters';

export const bankAccountNumberSchema = z
  .string({ required_error: message })
  .min(5, { message })
  .max(17, { message })
  .refine((value: any) => /^[a-zA-Z0-9]*$/.test(value ?? ''), {
    message,
  });

const paymentSchema = z.object({
  payment_id: z.number(),
  payment_number: z.number(),
  payment_method_id: z.number().optional(),
  immediate: z.boolean().optional(),

  default_payment_method: z.boolean(),
  payment_method: z.string().optional(),

  card_number: z.string().optional(),
  expiration_date: z.string().optional(),
  security_code: z.string().optional(),
  zipcode: z.string().optional(),

  account_type: z.string().optional(),
  routing_number: z
    .string()
    .regex(/^\d{9}$/, 'The routing number must be exactly 9 digits')
    .optional(),
  bank_account_number: bankAccountNumberSchema.optional(),
});

export type PaymentForm = z.infer<typeof paymentSchema>;

export const paymentConfirmationModalResolver = zodResolver(paymentSchema);

export const paymentConfirmationModalDefault = {
  payment_id: undefined,
  payment_number: 1,
  payment_method_id: undefined,
  immediate: true,

  default_payment_method: true,
  payment_method: 'cc',

  card_number: '',
  expiration_date: '',
  security_code: '',
  zipcode: '',

  account_type: 'checking',
  routing_number: undefined,
  bank_account_number: undefined,
};
